import DocumentApi from "@infrastructure/document-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/common/helpers/api-helper";
export const getAssignmentsAndUserDocumentsAsync = createAsyncThunk('document/GetAllDocumentsAndAssignments', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DocumentApi.getAssignmentsAndUserDocuments();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
